export default __webpack_public_path__ + "static/media/100_19429.6861536c.jpg";